import React, { useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { IS_MOCK } from "../utils/mockData";
import { useStandaloneContext } from "../context/StandaloneContext";

const PrivateOutlet = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const userData = useSelector((state) => state.account.userData);
  const { isStandalone, isAuthenticating } = useStandaloneContext();
  const isInHouseRoute = location.pathname.startsWith("/inhouse-games");

  useEffect(() => {
    if (isStandalone) return;
    // Allow inhouse game routes and lobby to render without casino auth
    if (location.pathname.startsWith("/inhouse-games") || location.pathname === "/lobby") return;
    if (!IS_MOCK && !userData?.token) navigate("/");
  }, [navigate, userData?.token, isStandalone, location.pathname]);

  useEffect(() => {
    if (!isInHouseRoute) return undefined;

    document.documentElement.classList.add("inhouse-route-active");
    document.body.classList.add("inhouse-route-active");

    return () => {
      document.documentElement.classList.remove("inhouse-route-active");
      document.body.classList.remove("inhouse-route-active");
    };
  }, [isInHouseRoute]);

  if (isStandalone && isAuthenticating) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div className="spinner-border" role="status">
          <span>Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        className={`container-fluid container-fluid-5 snipcss-fJ9mV${
          isInHouseRoute ? " inhouse-route-shell" : ""
        }`}
      >
        <div className="row row5">
          <Box className="content-box-main">{props.children}</Box>
        </div>
      </div>
    </>
  );
};

export default PrivateOutlet;
